import { ReactNode, Suspense } from 'react';

import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from './ErrorBoundary';

type SuspenseBoundaryProps = {
  children: ReactNode;
  loadingFallback?: ReactNode;
  errorFallback?: (args: { error: Error; reset: () => void }) => ReactNode;
  onReset?: () => void;
};

export function SuspenseBoundary({
  children,
  loadingFallback,
  errorFallback,
  onReset,
}: SuspenseBoundaryProps) {
  const { t } = useTranslation();
  return (
    <ErrorBoundary fallback={errorFallback} onReset={onReset}>
      <Suspense
        fallback={loadingFallback ?? <div>{t('common.loading')}...</div>}
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
